import { useStore } from 'vuex'
import { onMounted,computed, ref } from 'vue'
import formatNewlines from 'foundation/js/formatNewlines'

export default {
    name: "MemberOverlayProfileCard",
    setup(){
        const store = useStore()

        const isSubmitting = computed(()=> store.state.frivilligprofil.is_submitting)
        const userProfileId = computed(() => store.state.main.page_overlay_content_data.userId)

        const memberData = computed(()=>{
            return store.state.frivilligprofil.member_data
        })

        const memberDataFetched = ref(false);

        onMounted(() => {
            store.dispatch('frivilligprofil/fetchMemberData', {
                pageId: store.state.main.page_id,
                userProfileId: userProfileId.value
            }).then(() => 
                memberDataFetched.value = true
            )
        })

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "MemberOverlayProfileCard",
                labelKey: labelKey,
            });
        
        return {
            memberDataFetched,
            memberData,
            isSubmitting,
            getLabel,
            formatNewlines
        }
    }
}